import React from 'react';
import { Button, Select, Drawer } from 'antd';
import { COLORS } from '../../../constants/colors';

const { Option } = Select;

const EventTypeFilterDrawer = ({
  visible,
  filters,
  onFiltersChange,
  onClose
}) => {
  return (
    <Drawer
      title="Filters"
      placement="right"
      onClose={onClose}
      open={visible}
      width={300}
      styles={{
        body: { padding: '16px' }
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* Status Filter */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label style={{
            fontSize: '13px',
            fontWeight: '600',
            color: COLORS.textDark,
            marginBottom: '4px'
          }}>
            Status
          </label>
          <Select
            placeholder="All Statuses"
            style={{ width: '100%', height: '48px' }}
            value={filters.status}
            onChange={(value) => onFiltersChange({ ...filters, status: value })}
            allowClear
          >
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
          </Select>
        </div>

        {/* Action Buttons */}
        <div style={{
          marginTop: '24px',
          paddingTop: '16px',
          borderTop: `1px solid ${COLORS.border}`,
          display: 'flex',
          gap: '8px'
        }}>
          <Button
            onClick={() => {
              onFiltersChange({ search: '', status: undefined, color: undefined });
              onClose();
            }}
            style={{ flex: 1 }}
          >
            Clear
          </Button>
          <Button
            type="primary"
            onClick={onClose}
            style={{
              flex: 1,
              background: COLORS.$primaryBlue,
              borderColor: COLORS.$primaryBlue
            }}
          >
            Apply
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default EventTypeFilterDrawer;
